module.exports = __webpack_public_path__ + "img/Type_Dragon.1003e5ab.png";